import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { MapPin } from "lucide-react";

interface OpportunityModalHeaderProps {
  profileData: {
    full_name?: string | null;
    avatar_url?: string | null;
    job_title?: string | null;
    company?: string | null;
    location?: string | null;
    bio?: string | null;
  };
}

export const OpportunityModalHeader = ({ profileData }: OpportunityModalHeaderProps) => {
  return (
    <>
      <DialogHeader>
        <DialogTitle>Opportunity Details</DialogTitle>
      </DialogHeader>
      <div className="flex items-start gap-4 p-4 bg-muted/30 rounded-lg">
        <Avatar className="h-12 w-12">
          <AvatarImage src={profileData.avatar_url || ''} />
          <AvatarFallback>
            {profileData.full_name?.charAt(0) || 'CD'}
          </AvatarFallback>
        </Avatar>
        <div>
          <h3 className="font-semibold">{profileData.full_name}</h3>
          <p className="text-sm text-muted-foreground">{profileData.job_title}</p>
          <p className="text-sm text-muted-foreground">{profileData.company}</p>
          {profileData.location && (
            <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1">
              <MapPin className="h-3 w-3" />
              {profileData.location}
            </p>
          )}
          {profileData.bio && (
            <p className="text-sm mt-2">{profileData.bio}</p>
          )}
        </div>
      </div>
    </>
  );
};